// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LZR4","left":"styles_left__1dmjH"};